import { Component, OnInit } from '@angular/core';
import { ConcurrenceTime } from '../../../../shared/constants/Concurrences';
import { TranslatorService } from '../../../../shared/services/utils/translator.service';
import { DropdownBaseComponent } from '../dropdown-base.component';
import { DropDownService } from '../dropdown.service';

@Component({
  selector: 'ngx-concurrence-config-dropdown',
  templateUrl: '../template-dropdown.html'
})
export class ConcurrenceConfigDropdownComponent extends DropdownBaseComponent implements OnInit {

  constructor(
    private readonly dropdownService: DropDownService,
    protected readonly translatorService: TranslatorService
  ) {
    super(translatorService);
  }

  ngOnInit(): void {
    super.ngOnInit();

    this.dropDownSettings = this.dropdownService.getConfiguration(this.singleSelection);
    this.itemsData = [
      { id: ConcurrenceTime.DISABLED, name: this.translatorService.trans('concurrence.time.' + ConcurrenceTime.DISABLED) },
      { id: ConcurrenceTime.WITHOUT_TIME, name: this.translatorService.trans('concurrence.time.' + ConcurrenceTime.WITHOUT_TIME) },
      { id: ConcurrenceTime.SAME_DAY, name: this.translatorService.trans('concurrence.time.' + ConcurrenceTime.SAME_DAY) },
      { id: ConcurrenceTime.ONE_DAY, name: this.translatorService.trans('concurrence.time.' + ConcurrenceTime.ONE_DAY) },
      { id: ConcurrenceTime.SEVEN_DAYS, name: this.translatorService.trans('concurrence.time.' + ConcurrenceTime.SEVEN_DAYS) },
      { id: ConcurrenceTime.FIFTEEN_DAYS, name: this.translatorService.trans('concurrence.time.' + ConcurrenceTime.FIFTEEN_DAYS) },
      { id: ConcurrenceTime.ONE_MONTH, name: this.translatorService.trans('concurrence.time.' + ConcurrenceTime.ONE_MONTH) },
      { id: ConcurrenceTime.TWO_MONTH, name: this.translatorService.trans('concurrence.time.' + ConcurrenceTime.TWO_MONTH) },
      { id: ConcurrenceTime.THREE_MONTH, name: this.translatorService.trans('concurrence.time.' + ConcurrenceTime.THREE_MONTH) },
      { id: ConcurrenceTime.FOUR_MONTH, name: this.translatorService.trans('concurrence.time.' + ConcurrenceTime.FOUR_MONTH) },
      { id: ConcurrenceTime.FIVE_MONTH, name: this.translatorService.trans('concurrence.time.' + ConcurrenceTime.FIVE_MONTH) },
      { id: ConcurrenceTime.SIX_MONTH, name: this.translatorService.trans('concurrence.time.' + ConcurrenceTime.SIX_MONTH) },
      { id: ConcurrenceTime.ONE_YEAR, name: this.translatorService.trans('concurrence.time.' + ConcurrenceTime.ONE_YEAR) },
    ];
  }

}
